import { render, staticRenderFns } from "./Commissioned.vue?vue&type=template&id=36729a45"
import script from "./Commissioned.vue?vue&type=script&lang=js"
export * from "./Commissioned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports